import { connectedStore } from '../../store';
import selectors from '../selectors';

const getSiteProperties = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getSiteProperties(state);
};

export default getSiteProperties;
